module.exports = __webpack_public_path__ + "static/media/india-template.4594ba71.png";